import request from '../helpers'
import store from '@/store'
const state = {
  loading: false,
  dashboard: {
      waybills:0,
      trucks:0,
      pendingWaybills:0,
      approvedWaybills:0,
      packages:0
  }
}

const mutations = {
    CHANGE_LOADING_STATE(state, loading) {
      state.loading = loading
    },
    SET_ENTITY (state, entity) {
      state.dashboard = entity.entity
    }
}

const actions = {
    getDashboard({ commit }) {
      return request({ commit: commit, method: 'get', url: `app/dashboard`, successCallback: entities => {
        var payload = {state:state, entity: entities}
        commit('SET_ENTITY', payload);
      }});
    }
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  